import React from 'react';
import { observer } from 'mobx-react';
import { NikoCreateNewPatientModalTemplate } from 'themes/application/niko-patient/components';
import { setCurrentView } from 'core/utils';
import { NikoCreateNewPatientModalStore } from 'application/niko-patient/stores';

@setCurrentView((rootStore, componentProps) => new NikoCreateNewPatientModalStore(rootStore, componentProps), 'nikoCreateNewPatientModalStore')
@observer
class NikoCreateNewPatientModal extends React.Component {
    render() {
        return <NikoCreateNewPatientModalTemplate {...this.props} />
    }
}

export default NikoCreateNewPatientModal;
